import React from 'react';
import markdownContent from '!!raw-loader!static/imprint.md';
import { Markdown } from 'Common';

export const AppImprintPage = () => {
  return <Markdown className="app" scrollOffset={-10}>{markdownContent}</Markdown>;
};
